module.exports = __webpack_public_path__ + "img/marvel.8a18ea85.jpeg";